import { useEffect, useRef } from "react";

/** Adds `is-visible` to elements with class `reveal` inside the returned ref once they scroll into view. */
export function useReveal() {
  const scopeRef = useRef(null);

  useEffect(() => {
    const scope = scopeRef.current;
    if (!scope) return;

    const targets = scope.classList.contains("reveal")
      ? [scope, ...scope.querySelectorAll(".reveal")]
      : [...scope.querySelectorAll(".reveal")];

    if (targets.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return scopeRef;
}
